<script setup lang="ts">
import { BackgroundPaths } from '@/components/ui/background-paths'
</script>

<template>
  <ClientOnly>
    <BackgroundPaths title="Background Paths" />
  </ClientOnly>
</template>
